import { VField } from '../../components/Fields'
import { USER_ROLES_UTENTI } from '../../constants'

export default function FormUtente() {
  return (
    <div className="row">
      <div className="col-6">
        <VField name="full_name" label="Nome e Cognome" type="text" required />
      </div>
      <div className="col-6">
        <VField name="email" label="Email" type="email" required />
      </div>
      <div className="col-6">
        <VField name="role" label="Ruolo" as="select" required>
          <option value="">Seleziona un ruolo</option>
          {Object.values(USER_ROLES_UTENTI).map((role) => (
            <option key={role.value} value={role.value}>
              {role.label}
            </option>
          ))}
        </VField>
      </div>
    </div>
  )
}
